import "./lib/globals";
import { createApp } from "vue";
import { createPinia } from "pinia";
import { $api, $socket } from "./lib";
import { useGameStore, useUserStore } from "./stores";
import { router } from "./router/index";
import InlineSVG from "vue-inline-svg";
import App from "./App.vue";
import "./components/core/ResettableObject";
import { vConfirmClick, vDisabledClick } from "./directives";
import { createVuetify } from "vuetify";
import "vuetify/styles";
import "./assets/index.css";

// import { aliases, mdi } from "vuetify/iconsets/mdi-svg";

const vuetify = createVuetify({
	theme: {
		defaultTheme: "dark",
		themes: {
			dark: {
				dark: true,
				colors: {
					primary: "#E5BE01",
					secondary: "#212121",
					background: "#1a1a1a",
				},
			},
		},
	},
});

const pinia = createPinia();

const app = createApp(App);

//	When using directives (aka custom attributes), if the directive name (first argument) is prefixed with v-, it will won't work.
// Also, the directive component (second argument) must be named as vCamelCase.
app.directive("confirm-click", vConfirmClick);
app.directive("disabled-click", vDisabledClick);

app.component("i-svg", InlineSVG);

app.use(vuetify).use(pinia).use(router);

app.mount("#app");
const $$game = useGameStore();
const $$user = useUserStore();
[
	app.config.globalProperties.$api,
	app.config.globalProperties.$socket,
	app.config.globalProperties.$$game,
	app.config.globalProperties.$$user,
] = [$api, $socket, $$game, $$user];
